import { render, staticRenderFns } from "./AccountVerificationView.vue?vue&type=template&id=e28304b8&scoped=true&"
import script from "./AccountVerificationView.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationView.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerificationView.vue?vue&type=style&index=0&id=e28304b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28304b8",
  null
  
)

export default component.exports